import React from 'react';

const SharedFooter = () => (
  <footer className="relative py-12 px-6 bg-gradient-to-br from-teal-900 to-blue-900 border-t border-teal-800">
    <div className="max-w-7xl mx-auto text-center text-teal-200">
      <p className="mb-4">Need assistance? Contact us anytime:</p>
      <div className="flex items-center justify-center gap-2 mb-4">
        <span className="text-white font-medium">contact@multisellerpro.com</span>
        <button
          onClick={(e) => { navigator.clipboard.writeText('contact@multisellerpro.com'); e.target.innerText = 'Copied!'; }}
          className="px-3 py-1 bg-teal-600 hover:bg-teal-700 text-white rounded transition-colors text-sm"
        >Copy</button>
      </div>
      <div className="mb-4 py-4 border-t border-teal-800">
        <p className="text-white font-medium mb-2">Want to earn 30% commission?</p>
        <p className="text-sm">Sign up, go to Settings, and grab your affiliate link to start earning!</p>
      </div>
      <div className="flex items-center justify-center gap-4 mb-2">
        <a href="/terms" className="text-xs text-gray-500 hover:text-gray-400 transition-colors">Terms</a>
        <span className="text-gray-600 text-xs">·</span>
        <a href="/privacy" className="text-xs text-gray-500 hover:text-gray-400 transition-colors">Privacy</a>
      </div>
      <p className="text-sm">© {new Date().getFullYear()} MultiSellerPro™.</p>
    </div>
  </footer>
);

export default SharedFooter;
